<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

         <b-col cols="12">
              <b-row class="mb-4 mx-3 justify-content-end">
                <b-col cols="auto" class="px-1">
                    <el-button type="default" 
                        @click="$refs.drawer_filter_credit_reports.viewFilterCreditReports()">
                        <b-icon icon="filter"></b-icon> Filter
                    </el-button>
                </b-col>
                <b-col cols="auto" class="px-1">
                    <el-button type="primary" @click="exportCreditReports">
                        <b-icon icon="download"></b-icon> Export
                    </el-button>
                </b-col>
                <!-- <b-col cols="12" md="8" class="d-md-flex">
                    <base-input
                        v-model="searchQuery"
                        v-on:input="debouncedHandler"
                        prepend-icon="fas fa-search"
                        placeholder="Search"
                    >
                    </base-input>
                </b-col> -->
                <!-- <b-col cols="12" md="4" class="d-flex justify-content-center d-md-block">
                    <b-button variant="outline-primary" class="float-md-right mx-2" disabled>
                        <b-icon icon="filter"></b-icon>
                        Filter
                    </b-button>
                </b-col> -->
            </b-row>
        </b-col>
        <!-- Drawer for Filter Leads -->
        <drawer-filter-credit-reports ref="drawer_filter_credit_reports" 
            @filter_by="filterBy($event)"></drawer-filter-credit-reports>
        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="tableData"
                style="width: 100%;"
            >
                <el-table-column
                    type="selection"
                    width="35"
                    class-name="px-2"
                ></el-table-column>

                <el-table-column
                    label="ID"
                    prop="credit_report_id"
                    width="80"
                >
                </el-table-column>

                <el-table-column
                    label="Customer Name/IC/ID"
                    prop="credit_report_cust_name"
                    width="280"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line text-break">{{ scope.row.credit_report_cust_name | formatUserName(25) }}</p>
                        <p class="bottom-line">{{ scope.row.credit_report_cust_ic }}</p>
                        <p class="bottom-line">{{ scope.row.credit_report_cust_id }}</p>
                    </template>
                </el-table-column>
							
								<!-- <el-table-column
                    prop="name"
                    min-width="150"
                >
										<template slot="header">
												<div class="d-inline-block">
														<div>Platform</div>
														<div><small>Request Datetime</small></div>
												</div>
										</template>
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.credit_report_platform}}</p>
                        <p class="mb-0 bottom-line">{{ scope.row.credit_report_request_datetime | dateTimeFormatString }}</p>
                    </template>
                </el-table-column> -->

                 <!-- PLATFORM WITH CBM AND CTOS -->
                <el-table-column
                  prop="name"
                  min-width="220"
                >
                  <template slot="header">
                    <div class="d-inline-block">
                      <div>Platform</div>
                      <div><small>Request Datetime</small></div>
                    </div>
                  </template>

                  <template slot-scope="scope">
                    <p class="mb-0 top-line">
                      {{
                        _gAuth.isAppSas()
                          ? scope.row.credit_report_platform
                          : scope.row.credit_report_platform === 'CBM'
                            ? 'Premium Report'
                            : scope.row.credit_report_platform === 'CTOS'
                              ? (scope.row.credit_report_consent_unsigned_url
                                  ? 'Comprehensive Report'
                                  : 'Premium Report')
                              : scope.row.credit_report_platform || '-'
                      }}
                    </p>

                    <p class="mb-0 bottom-line">
                      {{ scope.row.credit_report_request_datetime | dateTimeFormatString }}
                    </p>
                  </template>
                </el-table-column>

              <!-- PLATFORM WITH PREMIUM AND COMPERHENSIVE ONLY -->
						  <!-- <el-table-column
              prop="name"
              min-width="220"
              >
              <template slot="header">
                <div class="d-inline-block">
                  <div>Platform</div>
                  <div><small>Request Datetime</small></div>
                </div>
              </template>

              <template slot-scope="scope">
                <p class="mb-0 top-line">
                  {{
                    _gAuth.isAppSas()
                      ? scope.row.credit_report_platform
                      : scope.row.credit_report_platform === 'CBM'
                        ? 'Premium Report'
                        : scope.row.credit_report_platform === 'CTOS'
                          ? (scope.row.credit_report_consent_unsigned_url
                              ? 'Comprehensive Report'
                              : 'Premium Report')
                          : scope.row.credit_report_platform || '-'
                  }}
                </p>

                <p class="mb-0 bottom-line">
                  {{ scope.row.credit_report_request_datetime | dateTimeFormatString }}
                </p>
              </template>
            </el-table-column> -->

                <!-- <el-table-column
                    label="Prescreening Analysis Report"
                    min-width="170"
                    >
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview( row.credit_report_fintscore_unsigned_url)"
                            class="font-weight-bold"
                            v-if="!_gHlp.isEmpty(row.credit_report_fintscore_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column> -->
                
								<!-- <el-table-column
                    prop="credit_report_pdf_unsigned_url"
                    label="Credit Report"
                    min-width="170">
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview( row.credit_report_pdf_unsigned_url)"
                            class="font-weight-bold"
                            v-if="!_gHlp.isEmpty(row.credit_report_pdf_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                    v-if="_gAuth.isAppSas()"
                    prop="credit_report_pdf_unsigned_url"
                    label="Credit Report"
                    min-width="170">
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview( row.credit_report_pdf_unsigned_url)"
                            class="font-weight-bold"
                            v-if="!_gHlp.isEmpty(row.credit_report_pdf_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
								<el-table-column
                    prop="credit_report_consent_unsigned_url"
                    label="Consent Form"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_consent_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_consent_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                
								<el-table-column
                    prop="credit_report_ic_front_unsigned_url"
                    label="Front NRIC"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_ic_front_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_ic_front_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="credit_report_ic_back_unsigned_url"
                    label="Back NRIC"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_ic_back_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_ic_back_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ pagination.total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
        <PreviewModal ref="preview_modal"></PreviewModal>
    </b-card>
</template>
<script>
import { Table, TableColumn, Button, Dropdown, DropdownItem, DropdownMenu, Select, Option } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useConfigStore } from '@/stores/configStore'
import PreviewModal  from '@/components/Modal/PreviewModal'
import DrawerFilterCreditReports from '@/views/CreditReports/FilterCerditReports.vue'

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        PreviewModal,
        BasePagination,
        DrawerFilterCreditReports,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button, 
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch: ['credit_report_cust_name', 'credit_report_id', 'credit_report_cust_ic', 'credit_report_cust_id', 'credit_report_platform'],
            mode: 'listing',
            currentPage: 1,
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            pagination: {
							perPageOptions: [5, 10, 25, 50, 100, 500],
							currentPage: 1,
							perPage: 25,
							total: 0,
							from: null,
							to: null
						},
            filters: {
              customer_name: '',
              platform: '',
              requested_date: '',
              customer_nric: '',
            },
        }
    },
    created() {
        this.getCreditReportsList()
    },
    computed:{
        ...mapState(useAuthStore, ['viewable_customer_ids', 'auth_user']),
        ...mapState(useConfigStore, ['app_code']),
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        ...mapActions(useCustomerStore, ['getCustomerCount']),
         exportCreditReports() {
              // Specify the fields and their headers (including Platform)
              const fields = [
                { key: 'credit_report_id', label: 'Credit Report Id' },
                { key: 'credit_report_cust_name', label: 'Customer Name' },
                { key: 'credit_report_cust_id', label: 'Customer Id' },
                { key: 'credit_report_cust_ic', label: 'Customer Ic' },
                { key: 'credit_report_request_datetime', label: 'Requested Datetime' },
                { key: 'platform_label', label: 'Platform' }, // new
                { key: 'credit_report_created_by_details', label: 'Created By' }
              ];

              // Prepare CSV content
              const csvRows = [];

              // Header
              csvRows.push(fields.map(f => f.label).join(','));

              // Data
              this.tableData.forEach(row => {
                const values = fields.map(f => {
                  let value = '';

               if (f.key === 'platform_label') {
                    if (_gAuth.isAppSas()) {
                      // SAS app → show platform code directly
                      value = row.credit_report_platform || '';
                    } else {
                      // Other apps → map to user-friendly labels
                      if (row.credit_report_platform === 'CBM') {
                        value = 'Premium Report';
                      } else if (row.credit_report_platform === 'CTOS') {
                        value = row.credit_report_consent_unsigned_url
                          ? 'Comprehensive Report'
                          : 'Premium Report';
                      } else {
                        value = row.credit_report_platform || '';
                      }
                    }
                  } else {
                    value = row[f.key] ?? '';
                  }

                  // Format Customer Ic as string for Excel
                  if (f.key === 'credit_report_cust_ic' && value) {
                    value = `\t${value}`;
                  }

                  // Format Datetime
                  if (f.key === 'credit_report_request_datetime' && value) {
                    value = this.$options.filters && this.$options.filters.dateTimeFormatString
                      ? this.$options.filters.dateTimeFormatString(value)
                      : value;
                  }

                  // Get name from created_by_details object
                  if (f.key === 'credit_report_created_by_details') {
                    value = value && value.name ? value.name : '';
                  }

                  // Escape quotes
                  return `"${String(value).replace(/"/g, '""')}"`;
                });
                csvRows.push(values.join(','));
              });

              // Create and download CSV file
              const csvContent = csvRows.join('\n');
              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              const now = new Date();
              const pad = n => n.toString().padStart(2, '0');
              const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
              link.setAttribute('download', `credit_reports_${timestamp}.csv`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            },
        filterBy(event) {
            this.filters.requested_date = event.date_range
            this.filters.customer_name = event.customer_name
            this.filters.platform = event.platform
            // this.filters.requested_date = event.requested_date
            this.filters.customer_nric = event.customer_nric
            this.drawerFilterCreditReports = false
            this.pagination.currentPage = 1
            this.getCreditReportsList()
        },
        filterByDate($e) {
          this.selectedDates = []
          if ($e) {
            $e.forEach(element => {
              this.selectedDates.push(element)
            });
          }
          this.getListing()
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
          this.pagination.currentPage = page
					this.getCreditReportsList();
        },
        // async getCreditReportsList() {
        //     this.isTableLoading = true

				// 		let queryParams = _gHlp.generateQueryParams({
				// 			paginate:this.pagination.perPage,
				// 			page:this.pagination.currentPage,
				// 			orderBy:{
				// 				credit_report_id:'desc'
				// 			},
				// 			search:{
				// 				credit_report_status:'completed',	
				// 				credit_report_application_code:this.app_code,	
				// 			}
				// 		})

        //     const url = `${services.commitment}credit-reports?${queryParams}`
        //     axios.get(url, {headers: getHeader()})
        //     .then(res => {
        //         this.tableData = res.data.data
				// 				this.pagination = _gHlp.setPaginate(res.data.meta)
				// 				this.isTableLoading = false
        //     }).catch(e => {
				// 				this.is_loading = false
        //         this.errorFunction(e)
        //     })
        // }
          async getCreditReportsList() {
            this.isTableLoading = true
        
            // Build search params including filters
            let searchParams = {
                credit_report_status: 'completed',
                credit_report_application_code: this.app_code,
            };
            // Role-based filtering
            if (
                _gAuth.isAppSas() &&
                !_gHlp.checkRoleType(['admin', 'manager', 'director']) &&
                this.auth_user &&
                this.auth_user.id
            ) {
                searchParams.credit_report_created_by = this.auth_user.id;
            }

            if (this.filters.customer_name) {
                searchParams.credit_report_cust_name = this.filters.customer_name;
            }
            // if (this.filters.platform) {
            //     // Map display names to platform codes
            //     if (this.filters.platform === 'Comprehensive Report') {
            //         searchParams.credit_report_platform = 'CTOS';
            //     } else if (this.filters.platform === 'Premium Report') {
            //         searchParams.credit_report_platform = 'CBM';
            //     } else {
            //         searchParams.credit_report_platform = this.filters.platform;
            //     }
            // }
            if (this.filters.platform) {
                const platformMap = {
                    'comprehensive': 'CTOS',
                    'comprehensivereport': 'CTOS',
                    'comprehensive report': 'CTOS',
                    'premium': 'CBM',
                    'premiumreport': 'CBM',
                    'premium report': 'CBM'
                };

                const key = this.filters.platform.toLowerCase().replace(/\s+/g, '');
                searchParams.credit_report_platform = platformMap[key] || this.filters.platform;
            }

            if (this.filters.customer_nric) {
                searchParams.credit_report_cust_ic = this.filters.customer_nric;
            }
            // if (this.filters.datetime) {
            //   searchParams.credit_report_date_type = 'credit_report_request_datetime';
            //   searchParams.credit_report_date_start = this.filters.datetime;
            // }
            if (this.filters.requested_date) {
              searchParams.credit_report_request_datetime = this.filters.requested_date;
            }

        
            let queryParams = _gHlp.generateQueryParams({
                paginate: this.pagination.perPage,
                page: this.pagination.currentPage,
                orderBy: {
                    credit_report_id: 'desc'
                },
                search: searchParams
            });
        
            const url = `${services.commitment}credit-reports?${queryParams}`
            axios.get(url, {headers: getHeader()})
                .then(res => {
                   let data = res.data.data;

                    // 🔥 Hide CTOS records if app is not SAS
                    if (!_gAuth.isAppSas()) {
                      data = data.filter(item => item.credit_report_platform !== 'CTOS');
                    }

                    this.tableData = data;
                    this.pagination = _gHlp.setPaginate(res.data.meta)
                    this.isTableLoading = false
                }).catch(e => {
                    this.is_loading = false
                    this.errorFunction(e)
                })
        }
    }
}
</script>